import React, { useState, useContext, useEffect } from 'react'
import defaultMarkerIconPng from "leaflet/dist/images/marker-icon.png";
import SideBarLayout2 from '../layouts/SideBarLayout2'
import { useLocation, useNavigate } from 'react-router-dom'
import AppInput from '../components/formik/AppInput'
import * as Yup from 'yup'
import { Formik } from 'formik'
import NavCard from '../components/NavCard'
import { faDiagramProject, faUserGroup } from '@fortawesome/free-solid-svg-icons'
import AppTextArea from '../components/formik/AppTextArea'
import Button from '../components/Button'
import AppContext from '../contexts/AppContext';
import { MapContainer, TileLayer, Marker } from 'react-leaflet'
import { Icon } from 'leaflet'

const validationSchema = Yup.object().shape({
    name: Yup.string().required().label("Name"),
    code: Yup.string().required().label("Code"),
    description: Yup.string().required().label("description"),
});

export default function ProjectInfo() {
    const location = useLocation()
    const { state } = location
    const [disabled, setDisabled] = useState(true)
    const [editDisabled, setEditDisabled] = useState(false)
    const navigate = useNavigate();
    const { user } = useContext(AppContext)

    const onSubmit = () => {

    }
    console.log(state);
    return (
        <SideBarLayout2 title={'Project Details'}>


            <div className='mx-5 bg-gray-100 shadow-lg mt-16 px-5 pt-5 w-full flex font-dmsans'>
                <div className='w-2/3 p-4 bg-white mx-5 rounded-lg h-[80vh] overflow-y-scroll'>
                    <div className='flex justify-between p-2 border-b-2 border-slate-300 h-14 rounded-t-lg'>
                        <div className='flex font-dmsans items-center'>
                            <svg fill="none" viewBox="0 0 24 24" height="28" width="28" className='rounded-full border-2 border-slate-300 p-1 mr-1'>
                                <path fill="currentColor" d="M2 8a1 1 0 011-1h18a1 1 0 110 2H3a1 1 0 01-1-1zM2 12a1 1 0 011-1h18a1 1 0 110 2H3a1 1 0 01-1-1zM3 15a1 1 0 100 2h12a1 1 0 100-2H3z" />
                            </svg>
                            <div className='flex flex-col'>
                                <span className='text-md font-semibold'>Project Info</span>
                                <span className='text-xs '>Write your form with intent.</span>
                            </div>
                        </div>
                        <div className='flex items-center'>
                            <button className='p-1 border-2 border-slate-300 rounded-lg text-xs'>Examples</button>
                        </div>
                    </div>



                    <Formik
                        initialValues={{ name: state?.project.name, code: state?.project.code, description: state?.project.description }}
                        validationSchema={validationSchema}
                        onSubmit={onSubmit}
                    >
                        <>
                            <div className='m-2 border-2 border-slate-300 rounded-lg p-4'>
                                <div className='font-dmsans'>Date created - {location.state?.project.createdAt}</div>
                                <AppInput boxClassName={'w-full '} disabled={true} name={'code'} inputclassName={'font-dmsans'} placeholder={'AB12'} label={'Code'} labelclassName={'font-dmsans'} type={'text'} />
                                <AppInput boxClassName={'w-full '} disabled={disabled} name={'name'} placeholder={'New Project'} label={'Name'} labelclassName={'font-dmsans'} type={'text'} />
                            </div>

                            <div className='m-2 border-2 border-slate-300 rounded-lg p-4'>

                                <div className='flex font-dmsans items-center border-b-2 pb-1'>
                                    <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} viewBox="0 0 24 24" height="26" width="26">
                                        <path stroke="none" d="M0 0h24v24H0z" />
                                        <path d="M14 3v4a1 1 0 001 1h4" />
                                        <path d="M17 21H7a2 2 0 01-2-2V5a2 2 0 012-2h7l5 5v11a2 2 0 01-2 2zM9 17h6M9 13h6" />
                                    </svg>

                                    <span className='text-sm font-semibold'>Description</span>
                                </div>
                                <AppTextArea rows={10} disabled={disabled} name={'description'} placeholder={'Say something about this project'} label={'Project Description'} />

                            </div>
                        </>
                    </Formik>
                    <div className='flex'>
                        <Button disabled={editDisabled} className={' flex bg-blue-500 text-white mt-20 font-dmsans'} onClick={() => { setDisabled(false); setEditDisabled(true) }} >
                            <svg viewBox="0 0 1024 1024" fill="currentColor" height="26" width="26" className='mr-1'>
                                <path d="M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z" />
                            </svg>
                            Edit
                        </Button>
                        <Button className={'flex bg-green-500 text-white ml-10 mt-20 font-dmsans'} onClick={() => { setEditDisabled(false); setDisabled(true) }} >
                            <svg fill="none" viewBox="0 0 15 15" height="26" width="26" className='mr-1'>
                                <path fill="currentColor" fillRule="evenodd" d="M1.903 7.297c0 3.044 2.207 5.118 4.686 5.547a.521.521 0 11-.178 1.027C3.5 13.367.861 10.913.861 7.297c0-1.537.699-2.745 1.515-3.663.585-.658 1.254-1.193 1.792-1.602H2.532a.5.5 0 010-1h3a.5.5 0 01.5.5v3a.5.5 0 01-1 0V2.686l-.001.002c-.572.43-1.27.957-1.875 1.638-.715.804-1.253 1.776-1.253 2.97zm11.108.406c0-3.012-2.16-5.073-4.607-5.533a.521.521 0 11.192-1.024c2.874.54 5.457 2.98 5.457 6.557 0 1.537-.699 2.744-1.515 3.663-.585.658-1.254 1.193-1.792 1.602h1.636a.5.5 0 110 1h-3a.5.5 0 01-.5-.5v-3a.5.5 0 111 0v1.845h.002c.571-.432 1.27-.958 1.874-1.64.715-.803 1.253-1.775 1.253-2.97z" clipRule="evenodd" />
                            </svg>
                            Update
                        </Button>
                    </div>

                </div>
                <div className='w-1/3 p-5 h-[80vh] overflow-y-scroll'>

                    <div className='mt-4'>
                        <MapContainer
                            style={{
                                height: 350,
                                width: '100%',
                            }}
                            // minZoom={3} // just added so you cannot go out of area
                            zoom={3}
                            center={state?.project.location.coordinates}
                        >
                            <TileLayer
                                url={'https://basemap.nationalmap.gov/arcgis/rest/services/USGSImageryTopo/MapServer/tile/{z}/{y}/{x}'}
                                attribution={'Tiles courtesy of the <a href="https://usgs.gov/">U.S. Geological Survey</a>'}
                            />
                            <Marker position={state?.project.location.coordinates} icon={new Icon({ iconUrl: defaultMarkerIconPng, iconSize: [25, 41] })}>
                            </Marker>
                        </MapContainer>
                    </div>
                    <div className='w-full flex gap-2 mt-5'>
                        <NavCard className={' bg-zinc-500 hover:bg-zinc-600'} onClick={() => { navigate('/project-info/bowties', { state }) }} icon={faDiagramProject} title={'Risk Analysis'} />
                        <NavCard className={' bg-teal-500 hover:bg-teal-600'} onClick={() => { navigate('/project-info/colabs', { state }) }} icon={faUserGroup} title={'Colaborators'} />
                    </div>
                </div>
            </div>







            {/* <div className="flex-1 bg-gray-100 shadow-lg mx-5 p-5 rounded">
            <div className='grid grid-cols-5 gap-5'>
                <div className='col-span-3 h-[80vh] overflow-y-scroll'>
                    <div>Date created - {location.state?.project.createdAt}</div>
                    <Formik
                    initialValues={{name: location.state?.project.name, code: location.state?.project.code, description: location.state?.project.description }}
                    validationSchema={validationSchema}
                    onSubmit={onSubmit}
                    >
                    <>
                        <AppInput boxClassName={'w-1/3'} disabled={true} name={'code'} placeholder={'AB12'} label={'Code'} type={'text'}/>
                        <AppInput boxClassName={'w-1/2'} disabled={disabled} name={'name'} placeholder={'New Project'} label={'Name'} type={'text'}/>
                        <AppTextArea rows={10} disabled={disabled} name={'description'} placeholder={'Say something about this project'} label={'Description'} />
                    </>
                    </Formik>
                    <Button disabled={editDisabled} className={'bg-blue-500 text-white mt-20'} onClick={()=>{setDisabled(false); setEditDisabled(true)}} >Edit</Button>
                    <Button className={'bg-green-500 text-white ml-10 mt-20'} onClick={()=>{setEditDisabled(false); setDisabled(true)}} >Update</Button>
                </div>
                <div className='col-span-2 grid grid-cols-2 gap-2'>
                    <Card className={'rounded-3xl bg-zinc-500 hover:bg-zinc-600'} onClick={()=>{navigate('/project-info/bowties', {state: {location} })}} icon={faDiagramProject} title={'Risk Analysis'} />
                    <Card className={'rounded-3xl bg-teal-500 hover:bg-teal-600'} onClick={()=>{navigate('/project-info/colabs',{state: {location} })}} icon={faUserGroup} title={'Colaborators'} />
                    <div className='col-span-2'>
                        <Map boxClassname={'rounded-3xl bg-transparent'} onClick={({ event, latLng, pixel })=>{}} 
                        provider={stamenToner} 
                        height={400}
                        defaultCenter={location.state?.project.location.coordinates}
                        defaultZoom={13}>
                        <Marker color='red' width={30} anchor={location.state?.project.location.coordinates} />
                        <ZoomControl />
                        </Map>
                    </div>
                </div>
            </div>
        </div>*/}
        </SideBarLayout2>
    )
}
